// extracted by mini-css-extract-plugin
module.exports = {"testMail":"testMail__z4hffzgGF8yqY","head":"head__jH5vIn5TX95y3","input":"input__U31Z8ae6oUN0Y","error":"error__z+Nu7eNoAkNgW"};